export default {
  namespaced: true,

  state: {

    cartItems: null,
    itemCount: null,
    wishlistItemCount: null,
    totalPrice: null,
    subtotalPrice: null,
    sideCart: false

  },

  getters: {

    getCartItems: state => {
      return state.cartItems;
    },

    getItemCount: state => {
      return state.itemCount;
    },

    getWishlistItemCount: state => {
      return state.wishlistItemCount;
    },

    getTotalPrice: state => {
      return state.totalPrice;
    },

    getSubtotalPrice: state => {
      return state.subtotalPrice;
    },

    getSideCart: state => {
      return state.sideCart;
    },
  },

  mutations: {

    setCartItems: (state, callback) => {
      state.cartItems = callback;
    },

    setItemCount: (state, callback) => {
      state.itemCount = callback;
    },

    setWishlistItemCount: (state, callback) => {
      state.wishlistItemCount = callback;
    },

    setTotalPrice: (state, callback) => {
      state.totalPrice = callback;
    },

    setSubtotalPrice: (state, callback) => {
      state.subtotalPrice = callback;
    },

    setSideCart: (state, callback) => {
      state.sideCart = callback
    }
  },

  actions: {

    changeCartItems: (context, callback) => {
      context.commit('setCartItems', callback);
    },

    changeItemCount: (context, callback) => {
      context.commit('setItemCount', callback);
    },

    changeWishlistItemCount: (context, callback) => {
      context.commit('setWishlistItemCount', callback);
    },

    changeTotalPrice: (context, callback) => {
        context.commit('setTotalPrice', callback);
    },

    changeSubtotalPrice: (context, callback) => {
      context.commit('setSubtotalPrice', callback);
    },

    changeSideCart: (context, callback) => {
      context.commit('setSideCart', callback);
    },

  },
}
